import FILTERS from "@/enum/Filters";
import { PROFILES } from "@/enum/Profiles";
import {
  userSettings,
  setUserStateSettings,
  saveUserSettings,
} from "@/globals/userSettings";
import addStylesheet from "@/utils/addStylesheet";
import { generateCSSFromConfig, injectToolCSS } from "@/utils/cssGenerator";
import enableContrast from "./enableContrast";
import renderTools from "@/views/menu/renderTools";
import selectButtons from "./selectButtons";

const FONT_SIZE_PROFILE_DEFAULT = 1.2;

export default function enableProfile(profile: string, $menu: HTMLElement) {
  const profileConfig = PROFILES[profile];
  if (!profileConfig) {
    return;
  }
  userSettings.states.contrast = profileConfig.contrast;
  enableContrast(profileConfig.contrast);
  profileConfig.tools.forEach((tool: string) => {
    if (tool === 'font-size') {
      // font-size is a numeric multiplier stored at states.fontSize, not a boolean
      const current = Number(userSettings.states.fontSize) || 1;
      if (current === 1) {
        userSettings.states.fontSize = FONT_SIZE_PROFILE_DEFAULT;
      }
    } else {
      userSettings.states[tool] = true;
    }
  });
  saveUserSettings();
  renderTools();
  selectButtons($menu);

  // Reflect the new fontSize multiplier in the "Adjust Font Size" UI counter.
  // selectButtons() handles boolean toggles via the cya11y-selected class, but
  // the percentage span is updated separately in renderMenu / on +/- click.
  const newFontSize = Number(userSettings.states.fontSize) || 1;
  const amountElement = $menu.querySelector(".cya11y-amount");
  if (amountElement) {
    amountElement.textContent = `${(newFontSize * 100).toFixed(0)}%`;
  }
}
